import React, { useEffect, useState, useContext } from "react";
import Layout from "./Layout";
import { UserService } from "../../services/user/userService";

const ParentLayout = () => {
  return (
    <>
      <UserService>
        <Layout />
      </UserService>
    </>
  );
};

export default ParentLayout;
